module.exports = __webpack_public_path__ + "static/fonts/Mont-Light.d203b37.woff";